var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntercom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#42a5f5",
    d: "M6,10c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4v28c0,2.2-1.8,4-4,4H10c-2.2,0-4-1.8-4-4V10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M24,30c-0.553,0-1-0.447-1-1V12c0-0.553,0.447-1,1-1s1,0.447,1,1v17C25,29.553,24.553,30,24,30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M18,29c-0.553,0-1-0.447-1-1V13c0-0.553,0.447-1,1-1s1,0.447,1,1v15C19,28.553,18.553,29,18,29z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M30,29c-0.553,0-1-0.447-1-1V13c0-0.553,0.447-1,1-1s1,0.447,1,1v15C31,28.553,30.553,29,30,29z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M36,27c-0.553,0-1-0.447-1-1V15c0-0.553,0.447-1,1-1s1,0.447,1,1v11C37,26.553,36.553,27,36,27z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M12,27c-0.553,0-1-0.447-1-1V15c0-0.553,0.447-1,1-1s1,0.447,1,1v11C13,26.553,12.553,27,12,27z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M24,37.346c-4.489,0-8.979-1.525-12.641-4.577c-0.424-0.354-0.481-0.984-0.128-1.409 c0.354-0.425,0.983-0.48,1.409-0.128c6.582,5.486,16.137,5.486,22.719,0c0.426-0.353,1.056-0.297,1.409,0.128 s0.296,1.056-0.128,1.409C32.979,35.82,28.489,37.346,24,37.346z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntercom);
export default __webpack_public_path__ + "static/media/intercom.8f2045e88a163b8823998e9f737764c7.svg";
export { ForwardRef as ReactComponent };